// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopCareerPath_wrapper__OPOrO","career-path-wrapper":"TopCareerPath_career-path-wrapper__1UTAj"};